// removed by extract-text-webpack-plugin
module.exports = {"marketTable":"_1cJVBHMl3CIZO3SEvAKQHI","pair":"IlKeH4vOAS2xNbUZ1FcT-","createDaiBtn":"_1zdIzrn8sAdiSAHKTixQkZ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/OasisMarketWidget.scss
// module id = 1140
// module chunks = 0